import React, { useState } from "react";
import {useForm} from "react-hook-form";
import axios from 'axios';
import GenericModal from '../../generic/modal';
import {
    Container,
    Button,
    Form,
    Col,
    Row,
  } from "react-bootstrap";

// import { css } from "@emotion/core";
// import CircleLoader from "react-spinners/CircleLoader";
import SyncLoader from "react-spinners/SyncLoader";
import ReactGA from 'react-ga';

export default function ForgotPassword() {
    ReactGA.pageview(window.location.pathname + window.location.search);    
    const [loading, setLoading] = useState(false);
    // const [email, setEmail] = useState('');

    const [success, setSuccess] = useState(false);
    const [show, setShow] = useState(false);
    const {register, handleSubmit} = useForm();

    const onSubmit = async (data) => {
        setLoading(true);
        axios.post('https://uae-dentist-backend.herokuapp.com/mail/reset-password', data)
        .then(function (response) {
            setLoading(false);
            setShow(true);
            setSuccess(true);
            // setEmail(data.email);
        })
        .catch(function (error) {
            setLoading(false);
            setShow(true);
            setSuccess(false);
            console.log(error);
        });
    }

    return (
    <Container className="mt-5">
        { show && <GenericModal setShow={setShow} show={show} success={success}/>}
        <h4 className="mb-4">Recover password</h4>
        <Form onSubmit={handleSubmit(onSubmit)}>
        <Form.Group as={Row} controlId="formHorizontalEmail">
            <Form.Label column sm={2}>
                Email Address
            </Form.Label>
            <Col sm={6}>
            <Form.Control required type="email" name='email' placeholder="dentist@clinic.com" ref={register ({required:true})} />
            </Col>
        </Form.Group>

        <Form.Group as={Row}>
            <Col sm={{ span: 10, offset: 2 }}>
            <Button variant="primary" type="submit">Send email</Button>
        </Col>
        </Form.Group>
        <div className='mt-5'>
          <SyncLoader
            size={15}
            margin={2}
            color={"#123abc"}
            loading={loading}
          />
        </div>
        </Form>
    </Container>
    )
}